<template>
  <div data-app>
    <div
      role="alert"
      v-bind:class="{ show: errors.length }"
      class="alert fade alert-danger"
    >
      <div class="alert-text" v-for="(error, i) in errors" :key="i">
        {{ error }}
      </div>
    </div>

    <v-card>
      <v-card-title>ASNs</v-card-title>
      <v-card-subtitle>ASNs associated with this account.</v-card-subtitle>
      <v-data-table
        v-model="selected"
        :loading="loading"
        :headers="headers"
        :items="asns"
        :footer-props="{
          itemsPerPageOptions: [5, 10, 50, 100, 250, -1],
          showFirstLastPage: false,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-chevron-left',
          nextIcon: 'mdi-chevron-right',
        }"
        item-key="asn"
        class="elevation-1"
      >
        <template v-slot:item.as_sets="{ item }">
          {{ formatAsSets(item.as_sets) }}
        </template>
        <template v-slot:item.asn="{ item }">
          {{ formatAsn(item.asn) }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import api from "@/common/api.service";
import Errors from "@/common/errors";

export default {
  mounted() {
    this.loadData();
  },
  data: () => ({
    selected: [],
    headers: [
      { text: "ASN", align: "left", value: "asn" },
      { text: "AS-SETs", value: "as_sets" },
    ],
    asns: [],
    errors: [],
    loading: true,
  }),
  methods: {
    loadData() {
      this.loading = true;
      api
        .query("/v2/asns")
        .then((response) => {
          this.asns = response.data.asns || [];
        })
        .catch((error) => this.errors.push(...Errors.extractErrorMessage(error)))
        .finally(() => (this.loading = false));
    },
    formatAsSets(asSets) {
      if (!Array.isArray(asSets) || asSets.length === 0) return "";
      return asSets.join(", ");
    },
    formatAsn(asn) {
      return `AS${asn}`;
    },
  },
};
</script>
